import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Community.css";

const Community = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Professional Training for Your Furry Friend</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Trainers Card */}
        <div className="trainers-section">
          <div className="container">

            <div className="trainers-card">
            <div className="row">
              <div className="col-md-5">
                <div className="Community-content">
                <h1 className="font-bold mb-4">
                    Join our community of animal lovers
                  </h1>
                  <p className="font-semibold">
                    At EverythingPawzible, we believe every wag, purr, and pawprint has the power to create a kinder world. Join a community of passionate pet lovers who celebrate the joy, loyalty, and unconditional love our furry companions bring into our lives. Together, we share stories, support animal welfare, inspire responsible pet parenting, and make a difference—one paw at a time. If your heart beats a little faster for animals, you’ve already found your tribe. Welcome to EverythingPawzible, where every pet story matters. 🐾❤️
                  </p>
                  <a class="btn btn-dark rounded-pill px-4 w-50 mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal">
                    Join Us Now
                  </a>
                </div>
              </div>
              <div className="col-md-7 pe-0">
                <div className="Community-image">
                  <img
                    className="w-100"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/Community.png`}
                    alt="Banner_1"
                  />
                </div>
              </div>
            </div>
          </div>
            

          </div>
        </div>

      </section>
    </>
  );
};
export default Community;
